import { GridPostParams } from "common/models/utility-models/list-utility.model";

export class DashboardGridPostParams extends GridPostParams {
    fromDate_search:any = '';
    toDate_search:any = '';
}
